import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
/** Routing details are component memory only, never a query cache or persisted draft. */
export function useBankTransferInstructions(client, operationId, t0) {
  const $ = _c(10);
  const active = t0 === undefined ? true : t0;
  const [revision, setRevision] = useState(0);
  const [snapshot, setSnapshot] = useState(null);
  let t1;
  let t2;
  if ($[0] !== active || $[1] !== client || $[2] !== operationId || $[3] !== revision) {
    t1 = () => {
      if (!active) {
        return;
      }
      const controller = new AbortController();
      setSnapshot({
        revision,
        owner: client.cacheKey,
        operationId,
        data: null,
        failed: false
      });
      client.getBankTransferInstructions(operationId, controller.signal).then(data => {
        if (!controller.signal.aborted) {
          setSnapshot({
            revision,
            owner: client.cacheKey,
            operationId,
            data,
            failed: false
          });
        }
      }).catch(() => {
        if (!controller.signal.aborted) {
          setSnapshot({
            revision,
            owner: client.cacheKey,
            operationId,
            data: null,
            failed: true
          });
        }
      });
      return () => controller.abort();
    };
    t2 = [client, operationId, active, revision];
    $[0] = active;
    $[1] = client;
    $[2] = operationId;
    $[3] = revision;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  const current = active && snapshot?.revision === revision && snapshot.owner === client.cacheKey && snapshot.operationId === operationId ? snapshot : null;
  const t3 = current?.data ?? null;
  const t4 = current?.failed ?? false;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setRevision(_temp);
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t3 || $[8] !== t4) {
    t6 = {
      data: t3,
      failed: t4,
      retry: t5
    };
    $[7] = t3;
    $[8] = t4;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}
function _temp(value) {
  return value + 1;
}